import slideout from '../helpers/slideout';
import template from '../helpers/template';
import log from '../helpers/log';
import quantity from './quantity';
import overlay from './overlay';
import { debounce, isDesktop } from '../helpers/utilities';
import btnCheckout from './btnCheckout';
import cart from '../helpers/cart';
import lazyLoader from './lazyLoader';

interface IConfig {
  miniBasket: string
  view: string,
  desktopWidth: number,
  loadingClassName: string,
  selectors: IMiniBasketSelectors
}

interface IMiniBasketSelectors {
  remove: string,
  open: string,
  close: string,
  content: string
}

interface IUpdate {
  updates: IUpdateObject
}

interface IUpdateObject {
  [key: number]: number
}

class MiniBasket {

  private config:IConfig;
  private node:HTMLElement;
  private slideout:Slideout;

  constructor() {
    this.config = {
      desktopWidth: 360,
      miniBasket: '[data-mini-basket]',
      view: 'ajax-mini-basket',
      loadingClassName: 'mini-basket--loading',
      selectors: {
        remove: '[data-mini-basket-remove-btn]',
        open: '[data-mini-basket-open-btn]',
        close: '[data-mini-basket-close-btn]',
        content: '[data-mini-basket-content]'
      }
    }
  }

  public init() {
    this.node = document.querySelector(this.config.miniBasket);
    if (this.node) {
      this.slideout = this.getSlideoutByDevice();
      this.load();
    }
  }

  private getSlideoutByDevice() {
    if (isDesktop()) {
      return this.slideout = slideout.init(this.node, {
        side: 'right',
        padding: this.config.desktopWidth,
      });
    }

    return slideout.init(this.node, {
      side: 'right'
    });
  }

  private async load() {
    this.update();
  }

  public async update() {
    try {
      await template.getAndUpdateHTML({
        node: this.node, 
        content: this.config.selectors.content, 
        url: '/pages/mini-basket'
      });

      document.querySelectorAll(this.config.selectors.remove).forEach((htmlElement: HTMLElement) => {
        htmlElement.addEventListener('click', this.handleRemoveClick.bind(this))
      });

      document.querySelectorAll(this.config.selectors.open).forEach((htmlElement: HTMLElement) => {
        htmlElement.addEventListener('click', this.slideout.open.bind(this.slideout))
      });

      document.querySelectorAll(this.config.selectors.close).forEach((htmlElement: HTMLElement) => {
        htmlElement.addEventListener('click', this.slideout.close.bind(this.slideout))
      });

      this.updateItemAmount();

      quantity.init();
      btnCheckout.init();
      lazyLoader.update();
      btnCheckout.loaded();
    } 
    catch(error) {
      log.error(error);
    }
  }

  public async updateItemAmount() {
    try {
      const data: any = await cart.get();
      const { item_count:itemCount } = data.data;
      if (itemCount > 0) document.querySelectorAll('[data-mini-basket-items-amount]').forEach(htmlElement => htmlElement.innerHTML = itemCount);
    }
    catch(error) {
      log.error(error);
    }
    
  }

  public open() {
    this.slideout.open();
  }

  public close() {
    this.slideout.close();
  }

  private handleRemoveClick(event: Event) {
    event.preventDefault();
    const target = event.target as HTMLElement;
    if (target && target.dataset.variantId) this.remove(target.dataset.variantId);
  }

  public reinit = debounce(() => {
    if (this.node) {
      slideout.destroy(this.slideout);
      this.slideout = this.getSlideoutByDevice();
      this.load();
    }
  }, 250);

  public async remove(variantId: string) {
    btnCheckout.loading();
    const variantIdInt = parseInt(variantId);
    const updates:IUpdateObject = {};
    updates[variantIdInt] = 0;

    try {
      await cart.update({
        updates: updates
      });
    }
    catch(error) {
      log.error(error);
    }

    this.update();
  }
}

export default new MiniBasket();